import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {SessionService} from '../../../../services/session.service';

@Component({
  selector: 'app-promofirmas',
  templateUrl: './promofirmas.component.html',
  styleUrls: ['./promofirmas.component.scss']
})
export class PromofirmasComponent implements OnInit {

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: { type: any},
      private dialogRef: MatDialogRef<PromofirmasComponent>,
      private sessionService: SessionService,
      private router: Router
  ) { }

  ngOnInit(): void {
  }

  freeTest(): void {
    this.dialogRef.close();
    this.sessionService.setInitText(true);
    setTimeout(() => {
      if (this.router.url === '/firma-digital-gratis') {
        this.sessionService.emitNewSessionText(true);
      } else {
        this.router.navigate(['/firma-digital-gratis']);
      }
    }, 200);
  }

  close(): void {
    this.dialogRef.close();
  }

}
